<template>
  <el-menu
    :collapse="isCollapse"
    router
    class="el-menu-vertical-demo"
    :default-active="$route.path"
    :unique-opened="true"
    background-color="#2a3f54"
    text-color="#e7e7e7"
    active-text-color="#ffd04b">
    <el-submenu v-for="sub in menus" :key="sub.id" :index="sub.id.toString()">
      <template slot="title">
        <i :class="['iconfont', sub.icon_class]"></i>
        <span slot="title">{{ sub.name }}</span>
      </template>
      <el-menu-item v-for="m in sub.children" :key="m.id" :index="m.path || m.id.toString()">{{ m.name }}</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
export default {
  props: {
    user: Object,
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      menus: []
    }
  },
  computed: {
    firstIndex () {
      if (this.menus.length > 0) {
        return [this.menus[0].id.toString()]
      }
      return []
    }
  },
  mounted () {
    this.$http.get('/api/menu').then(response => {
      if (response.data.success) {
        this.menus = response.data.list
        if (this.user.finance_only === '1') {
          this.menus = this.menus.filter(r => r.id == 36) // 只显示财务板块
          if (this.user.group_id == 27) {
            this.menus[0].children.push({ 
              id: 45,
              name: '按单据退款',
              path: '/refund',
              leaf: '1',
              parent_id: 36,
              order_no: 9,
              icon_class: null
            })
          }
          this.$router.replace('/finance')
        }
      } else {
        this.$message({
          type: 'error',
          message: response.data.message
        })
      }
    })
  }
}
</script>

<style>
.el-menu {
  border-right: 0;
}
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  overflow-y: scroll;
}
.el-submenu__title i {
  color: #e7e7e7;
  vertical-align: middle;
  margin-right: 5px;
  width: 24px;
  text-align: center;
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/SideNav.vue